import { LoadingManager } from "@core/managers/loading.manager";
import { NotificationsManager } from "@core/managers/notifications.manager";
import { META_HTML_TITLE, META_LAYOUT } from "@core/constants";
import { ETAB_LAYOUTS, ETAB_ROUTES, META_DASHBOARD_SIDEMENU, META_DASHBOARD_TABS } from "@etab/config";
import { ACTION_SURVEY_GET_EXTRA_SCHEDULES, ACTION_SURVEY_GET_EXTRA_REVIEWS } from "@etab/stores/types";
import { useSurveyStore } from "@etab/stores/survey";

import SurveyPage from "./Survey.page.vue";

export default function () {
  return [
    {
      path: ETAB_ROUTES.survey.path,
      name: ETAB_ROUTES.survey.name,
      component: SurveyPage,
      meta: {
        [META_LAYOUT]: ETAB_LAYOUTS.dashboard,
        [META_DASHBOARD_TABS]: false,
        [META_DASHBOARD_SIDEMENU]: true,
        [META_HTML_TITLE]: "ETAB.PAGES.SURVEY.@TITLE",
      },
      async beforeEnter(to, from, next) {
        const surveyStore = useSurveyStore();
        try {
          LoadingManager.show();
          await Promise.all([
            // get the data before going to the page
            surveyStore[ACTION_SURVEY_GET_EXTRA_SCHEDULES](),
            surveyStore[ACTION_SURVEY_GET_EXTRA_REVIEWS](),
          ]);
          next();
        } catch (error) {
          NotificationsManager.contactEtabSupport();
          LoadingManager.hide();
        }
      },
    },
  ];
}
